/**
 * Whether an edit page was opened straight from creating its record. The
 * flag is read once and then cleared from history, so a reload or a later
 * visit through Back does not claim the record was just saved.
 */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Read by the edit page to open with "Saved" showing. */
export interface JustCreatedState {
  created: true;
}

export function useJustCreated(): boolean {
  const location = useLocation();
  const navigate = useNavigate();
  const [created] = useState(() => (location.state as JustCreatedState | null)?.created === true);
  useEffect(() => {
    if (created) navigate(location.pathname, { replace: true, state: null });
  }, [created, navigate, location.pathname]);
  return created;
}
